import React from 'react';
import BaseIcon from '@pedidosya/web-fenix/icons/BaseIcon'
import icon from './Icon_Peya_Plus_chip.svg';

export default function PeyaPlusChip(props) {
  const { iconProp } = props;
  return <BaseIcon icon={iconProp || icon} title="PedidosYa Plus" {...props} />;
}